import { Font, LightMode, LogoStyle, NavbarStyle, PageLayout, Size } from '../../constants';
import { ColorOption, NavbarThemeRevision } from 'referral-types';
import { ColorScheme } from '../theme/constants';

export const PAGE_NAME_REGEX = /^[a-zA-Z0-9-]+$/;

export function getDefaultPageNameFormValues() {
  return {
    pageName: '',
  };
}

export const getDisplayOptions = (options: Record<string, string>) =>
  Object.values(options).map((o) => ({ label: o, value: o }));

export const PlaceholderNavbarTheme: NavbarThemeRevision = {
  id: 'placeholder-navbar-theme-revision',
  createdDateTime: new Date(),
  lastModifiedDateTime: new Date(),
  navbarSize: Size.none,
  logoStyle: LogoStyle.default,
  navbarStyle: NavbarStyle.default,
  subTheme: ColorScheme.default,
  themeId: 'placeholder-navbar-theme',
  theme: {
    id: 'e81b2e5b-9648-4be7-9e63-91cfc9389ab6',
    createdDateTime: new Date(),
    lastModifiedDateTime: new Date(),
    title: 'Navbar Ultra',
    roleId: 'a2c1fb69-2158-4e5f-9b76-1b1d59ebbb91',
    isDefault: false,
    isBasic: false,
    collectionId: 'f35e268b-e46e-4315-9f07-80c955314dbb',
    collectionTier: 1,
    collectionTitle: 'Signature Navbar Collection',
    navbarSizeOptions: [Size.none, Size.sm, Size.md, Size.lg],
    defaultNavbarSize: Size.md,
    navbarStyleOptions: [NavbarStyle.default, NavbarStyle.minimalist],
    defaultNavbarStyle: NavbarStyle.default,
    logoStyleOptions: [LogoStyle.default, LogoStyle.custom],
    defaultLogoStyle: LogoStyle.default,
    subThemeOptions: [ColorScheme.default, ColorScheme.primary, ColorScheme.secondary, ColorScheme.tertiary],
    defaultSubTheme: ColorScheme.default,
  },
};

export const PlaceholderPageTheme = {
  id: '8f6b3e2d-9a1c-4f7b-a2e3-c5d7f9b0e1a4',
  createdDateTime: new Date('2025-08-31T20:27:33.000Z'),
  lastModifiedDateTime: new Date('2025-12-11T00:38:53.000Z'),
  themeId: '8f6b3e2d-9a1c-4f7b-a2e3-c5d7f9b0e1a4',
  theme: {
    id: '8f6b3e2d-9a1c-4f7b-a2e3-c5d7f9b0e1a4',
    createdDateTime: new Date('2025-08-31T20:27:33.000Z'),
    lastModifiedDateTime: new Date('2025-12-11T00:38:53.000Z'),
    title: 'Smart Color Palette',
    roleId: '7b4e2c9a-1f3d-4a8e-b5c2-d7f9e0a1b6c3',
    isDefault: false,
    isBasic: false,
    colorId: 10,
    colorOptions: ColorOption.all,
    defaultPrimaryColorHex: '#2563eb',
    defaultSecondaryColorHex: '#d97706',
    defaultTertiaryColorHex: '#fb2c36',
    pageSizeOptions: [Size.sm, Size.lg],
    defaultPageSize: Size.sm,
    pageLayoutOptions: [PageLayout.standard],
    defaultPageLayout: PageLayout.standard,
    lightModeOptions: [LightMode.light],
    defaultLightMode: LightMode.light,
  },
  font: Font.inter,
  primaryColorHex: '#2563eb',
  secondaryColorHex: '#d97706',
  tertiaryColorHex: '#fb2c36',
  pageSize: Size.lg,
  pageLayout: PageLayout.standard,
  lightMode: LightMode.light,
};
